import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../environments/environment';
import { Router } from '@angular/router';
import * as jwt_decode from 'jwt-decode';
import { Token } from '../models/interface-token';
import {Secuence} from '../models/interface-secuence';
import {GlobalService} from '../services/global.service';

@Injectable({
    providedIn: 'root'
})
export class ClientService {

    token: string;
    modalInfo: object = {};
    email: string;
    password: string;

    // SMS
    userPhone: string;
    allowActivationRoutes: boolean;
    dniSequence: string;
    smsSequence: string;
    finalSequence: string;

    constructor(private httpClient: HttpClient, private router: Router, private globalService: GlobalService) {
        this.token = '';
        this.allowActivationRoutes = false;
    }

    login(email, pass) {
        return this.httpClient.post<Token>(`${this.globalService.urlApiParam}/api/authenticate`, {
            email,
            password: pass
        });
    }

    logout() {
        if (this.getToken()) {
            localStorage.removeItem('token');
            document.getElementById('logout-modal').classList.add('d-none');
            this.router.navigateByUrl('');
        }
    }

    getToken() {
        return localStorage.getItem('token');
    }

    userLogedin() {
        if (this.getToken()) {
            return true;
        }
    }

    getTokenExpirationDate(token: string): Date {
        const decoded = jwt_decode(token);
        if (decoded.exp === undefined) {
            return null;
        }
        const date = new Date(0);
        date.setUTCSeconds(decoded.exp);
        return date;
    }

    isTokenExpired(token?: string): boolean {
        const date = this.getTokenExpirationDate(token);
        if (date === undefined) {
            return false;
        }
        return !(date.valueOf() > (new Date().valueOf()));
    }

    activateAccess(dni) {
        return this.httpClient.post<Secuence>(`${this.globalService.urlApiParam}/api/registerclient/newclientrequest`, {
            numDocumento: dni
        });
    }

    requestSmsCode() {
        return this.httpClient.post<Secuence>(`${this.globalService.urlApiParam}/api/registerclient/requestsmscode`, {
            sequence:  sessionStorage.getItem('sequence_activate_access')
        });
    }

    checkSmsCode(code, seq) {
        return this.httpClient.post<Secuence>(`${this.globalService.urlApiParam}/api/registerclient/checksmscode`, {
            smscode: code,
            sequence: seq
        });
    }

    clientAreaSignUp(email, pass, seq) {
        return this.httpClient.post(`${this.globalService.urlApiParam}/api/registerclient/savenewclient`, {
            email,
            password: pass,
            sequence: seq
        });
    }

    refreshToken() {
        const headers = new HttpHeaders({
            Authorization: `Bearer ${this.getToken()}`
        });
        this.httpClient.post<Token>(`${this.globalService.urlApiParam}/api/authenticate/refresh`, '', {headers}).subscribe(res => {
            localStorage.setItem('token', res.token);
        });
    }
}
